import React from "react";

const FormGroup = ({ label, required, error, children, style }) => (
  <div className={`form-group ${error ? "has-error" : ""}`} style={style}>
    {label && (
      <label className="form-label">
        {label}
        {required && <span className="required">*</span>}
      </label>
    )}
    {children}
    {error && <span className="field-error">{error}</span>}
  </div>
);

export default FormGroup;
